import gql from 'graphql-tag';

export const HeartbeatQuery = gql`
  query HeartbeatQuery {
    heartbeat @rest(type: "Heartbeat", path: "/heartbeat") {
      heartbeat
    }
  }
`;

export enum Heartbeat {
  OK = 'ok',
}

export type HeartbeatResponse = {
  heartbeat: Heartbeat.OK;
};
